module.exports = __webpack_public_path__ + "static/media/fb-login.9ea1fc42.webp";